import { Box, SxProps, Theme } from '@mui/material'

export interface ColumnsProps {
  columns: number
  children: React.ReactNode[]
  sx?: SxProps<Theme>
}

export function Columns(props: ColumnsProps): React.ReactElement {
  const { columns, children, sx } = props

  const split: React.ReactNode[][] = []
  const lines = Math.ceil(children.length / columns)

  for (let c = 0; c < columns; c++) {
    split.push([])
    for (let r = 0; r < lines; r++) {
      split[c].push(children[c * lines + r] || <></>)
    }
  }

  return <Box sx={{
    display: 'grid',
    gridTemplateColumns: `repeat(${columns}, 1fr)`,
    ...sx
  }}>
    {split.map((column, c) => <Box key={c} sx={{ }}>
      {column.map((row, r) => <Box key={r}>{row}</Box>)}
    </Box>)}
  </Box>
}
